<template>
  <div>
    <card>
      <h4 slot="header" class="card-title">
        參數設定、開發工具
      </h4>
    </card>
    <card>
      <EditAccountSettings />
    </card>
    <card>
      <LogisticPlaceOrder />
    </card>
    <card>
      <EditPrinterTemplate />
    </card>
    <card>
      <EditGoogleTagManager />
    </card>
  </div>
</template>

<script>
import axios from "axios";
import {
  getAccountData,
  getBusinessData,
  getPrinterTemplateById
} from "src/javascripts/generalPages/fetchData";

import { delStore } from "src/javascripts/generalPages/deleteData";
import {
  createPrinterTemplate,
  createLogisticOrder
} from "src/javascripts/generalPages/postData";
import {
  accountToggle,
  businessToggle,
  updatePrinterTemplateById
} from "src/javascripts/generalPages/updateData";

import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import swal from "sweetalert2";
import BoxBoolean from "./components/BoxBoolean.vue";
import BoxTextarea from "./components/BoxTextarea.vue";
import EditAccountSettings from "./components/EditAccountSettings.vue";
import LogisticPlaceOrder from "./components/LogisticPlaceOrder.vue";
import EditPrinterTemplate from "./components/EditPrinterTemplate.vue";
import EditGoogleTagManager from "./components/EditGoogleTagManager.vue";
import moment from "moment-timezone";

export default {
  components: {
    BoxBoolean,
    BoxTextarea,
    EditAccountSettings,
    LogisticPlaceOrder,
    EditPrinterTemplate,
    EditGoogleTagManager
  },
  data() {
    return {
      accountData: {},
      businessData: {},
      storeData: {},
      accountId: "",
      templateId: null,
      isUpdated: false,
      printerTemplateData: {
        update_at: ""
      },
      printerTemplateStatusOfUpdated: false,
      orderId: "",
      logisticRecallRes: "",
      callLogisticDisable: false
    };
  },
  mounted() {},
  computed: {
    displayPrinterTemplateStatusOfUpdated: function() {
      return this.printerTemplateStatusOfUpdated ? "已更新" : "";
    },
    displayPrinterTemplateUpdateAt: function() {
      return this.printerTemplateData["updated_at"]
        ? moment(this.printerTemplateData["updated_at"])
            .tz("Asia/Taipei")
            .format("YYYY-MM-DD HH:mm:ss")
        : "";
    }
  },
  methods: {
    logisticRecall(orderId) {
      let that = this;
      this.callLogisticDisable = true;
      this.$message({
        type: "info",
        message: "物流請求已送出"
      });
      createLogisticOrder(orderId)
        .then(createLogisticOrderRes => {
          that.logisticRecallRes = createLogisticOrderRes.data;
          that.orderId = "";
          that.callLogisticDisable = false;
        })
        .catch(createLogisticOrderErr => {
          that.logisticRecallRes = createLogisticOrderErr;
          that.callLogisticDisable = false;
        });
    },
    createPrinterTemplate() {
      console.log("createPrinterTemplate: ");
      let createPrinterTemplateData = {
        master: "<CB>快一點預設模板</CB><BR>",
        options: `{
"scheduleAt": ":scheduleAt<BR>",
"itemsTemplate" : "<L>:qty x :name </L><BR><RIGHT><BOLD>:optionsTemplate</BOLD></RIGHT>\n"
}`
      };
      let that = this;
      createPrinterTemplate(createPrinterTemplateData)
        .then(createPrinterTemplateRes => {
          console.log("createPrinterTemplateRes: ", createPrinterTemplateRes);
          let id = createPrinterTemplateRes.data.id;
          that.templateId = id;
          that.getTemplateSetting(id);
        })
        .catch(createPrinterTemplateErr => {
          console.log("createPrinterTemplateErr: ", createPrinterTemplateErr);
        });
    },
    getTemplateSetting(id) {
      console.log(id);
      this.printerTemplateStatusOfUpdated = false;
      let that = this;
      getPrinterTemplateById(id)
        .then(getPrinterTemplateByIdRes => {
          console.log("getPrinterTemplateByIdRes: ", getPrinterTemplateByIdRes);
          that.printerTemplateData = Object.assign(
            {},
            getPrinterTemplateByIdRes.data
          );
          that.printerTemplateMasterObj = Object.assign(
            {},
            {
              text: getPrinterTemplateByIdRes.data.master,
              update: false
            }
          );
          console.log(
            "that.printerTemplateMasterObj: ",
            that.printerTemplateMasterObj
          );
          that.printerTemplateOptionObj = Object.assign(
            {},
            {
              text: getPrinterTemplateByIdRes.data.options,
              update: false
            }
          );
        })
        .catch(getPrinterTemplateByIdErr => {
          console.log("getPrinterTemplateByIdErr: ", getPrinterTemplateByIdErr);
        });
    },
    onEditTextArea(e) {
      this.printerTemplateStatusOfUpdated = false;
      console.log("onEditTextArea: ", e);
    },
    onUpdateTextArea(e) {
      console.log("updateTextArea: ", e);
      // call update
      this.printerTemplateStatusOfUpdated = true;
      updatePrinterTemplateById(
        this.printerTemplateData.id,
        this.printerTemplateData
      )
        .then(updatePrinterTemplateByIdRes => {
          console.log(
            "updatePrinterTemplateByIdRes: ",
            updatePrinterTemplateByIdRes
          );
        })
        .catch(updatePrinterTemplateByIdErr => {
          console.log(
            "updatePrinterTemplateByIdErr: ",
            updatePrinterTemplateByIdErr
          );
        });
    },
    getData(accountId) {
      let that = this;
      that.accountData = Object.assign({});
      that.businessData = Object.assign({});
      if(accountId) {
        getAccountData(accountId)
          .then(getAccountDataRes => {
            that.accountData = Object.assign({}, getAccountDataRes.data);
          })
          .catch(getAccountDataErr => console.log(getAccountDataErr));

        getBusinessData(accountId)
          .then(getBusinessDataRes => {
            that.businessData = Object.assign({}, getBusinessDataRes.data);
          })
          .catch(getBusinessDataErr => console.log(getBusinessDataErr));
      } else {
        this.$message({
          type: "error",
          message: "Account ID是必填項目"
        });
      }
    },
    getAccountData() {},
    toBoolean(tinyInt) {
      return tinyInt == 1 ? true : false;
    },
    displayStats(tinyInt) {
      return tinyInt == 1 ? "啟用" : "關閉";
    },
    accountToggle(key) {
      this.accountData[key] = !this.accountData[key];
      this.accountData = Object.assign({}, this.accountData);
      accountToggle(this.accountId, key, this.accountData[key])
        .then(accountToggleRes =>
          console.log("accountToggleRes: ", accountToggleRes)
        )
        .catch(accountToggleErr =>
          console.log("accountToggleErr: ", accountToggleErr)
        );
      return;
    },
    businessToggle(key) {
      this.businessData[key] = !this.businessData[key];
      this.businessData = Object.assign({}, this.businessData);
      businessToggle(this.accountId, key, this.businessData[key])
        .then(businessToggleRes =>
          console.log("businessToggleRes: ", businessToggleRes)
        )
        .catch(accountToggleErr =>
          console.log("accountToggleErr: ", accountToggleErr)
        );
      return;
    },
    isShowAccount() {
      return Object.keys(this.accountData).length > 0;
    },
    isShowBusiness() {
      return Object.keys(this.businessData).length > 0;
    }
  }
};
</script>

<style>
.layout-style1 {
  color: rgb(0, 60, 255);
}
.layout-style2 {
  color: rgb(255, 102, 0);
}
.off {
  color: red;
}
.on {
  color: rgb(0, 255, 0);
}

.all-icons .font-icon-detail p {
  color: rgb(0, 0, 0);
  font-weight: bold;
  font-family: fantasy;
}
.top-position-132 {
  top: 132px;
}
.text-red {
  color: red;
}
</style>
